export const C1BorderRadius = {
    small: '4px',
    regular: '6px',
    medium: '8px',
    large: '10px',
    extraLarge: '20px',
}
